module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jamie Brenner\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Jamie Brenner")]), _vm._v(" is the nationally bestselling author of "), _c('I', [_vm._v("The Forever Summer")]), _vm._v(". Her novels include "), _c('I', [_vm._v("Blush")]), _vm._v(", "), _c('I', [_vm._v("Summer Longing, Drawing Home")]), _vm._v(", "), _c('I', [_vm._v("The Husband Hour")]), _vm._v(", "), _c('I', [_vm._v("The Wedding Sisters")]), _vm._v(", and "), _c('I', [_vm._v("The Gin Lovers")]), _vm._v(". She lives in New York City.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/14BvdGI/tc-custom/9781466845367.jpg?1723288489405",
      "alt": "This image is the cover for the book Wedding Sisters"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Wedding Sisters\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A devoted mother plans three weddings for three daughters—all on one day!—in this “witty, heartfelt, and fun” novel ("), _c('i', [_vm._v("Booklist")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v("It’s a dream come true when Meryl Becker’s oldest daughter gets engaged to a wonderful man from a prominent family. Now Meryl wants to give her the perfect wedding. But when her two younger daughters announce their own upcoming nuptials, Meryl has to admit that "), _c('i', [_vm._v("three")]), _vm._v(" perfect weddings is more than she and her husband can handle."), _c('br'), _c('br'), _vm._v("A triple wedding seems like the perfect solution . . . until Meryl discovers the logistical nightmare of juggling three sets of in-laws. And when word gets out, the onslaught of media attention adds unexpected pressure. Suddenly, appearances are everything, and Meryl will do whatever it takes to keep the wedding on track—even as her family starts to unravel.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0